import { MutableRefObject, useRef } from 'react';

import { IbUserAccountsAPIServiceTypes } from '../../services/IbUserAccountsServices/APIService';
import { IbUserAccountsAPIService } from '../../services/IbUserAccountsServices/APIService/index.api';
import { networkCallWithApisauce } from '../../utils/AuthAPIUtils';

const useIbUserAccountsRefreshTokenAPIService = () => {
  const IbUserAccountsRefreshTokenAPIRef: MutableRefObject<IbUserAccountsAPIServiceTypes | null> =
    useRef(null);

  if (IbUserAccountsRefreshTokenAPIRef.current === null) {
    IbUserAccountsRefreshTokenAPIRef.current = new IbUserAccountsAPIService(
      networkCallWithApisauce
    );
  }

  return {
    ibUserAccountsRefreshTokenAPIService:
      IbUserAccountsRefreshTokenAPIRef.current
  };
};

export { useIbUserAccountsRefreshTokenAPIService };
